import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import type { ClaimSetCreationState } from '@/domains/claimSets/store/types/ClaimSetCreationState';
import type { ClaimSetCreationIncidentType } from '@/domains/claimSets/types/ClaimSetCreation';
import type { ClaimSetCreationOptionsResponse } from '@/domains/claimSets/types/api/responses/ClaimSetCreationOptionsResponse';
import type { SelectOption } from '@/features/editMode/types/selectOption';
import { ClaimSetCreationStep } from '@/features/serviceModal/components/ClaimSetCreationModal/enums/ClaimSetCreationStep';

const initialState: ClaimSetCreationState = {
  form: {
    [ClaimSetCreationStep.IncidentType]: {
      IncidentTypeId: undefined,
    },
  },
  options: {
    claimTypes: [] as SelectOption[],
  },
  statuses: {
    isOptionsLoading: false,
    isCompleting: false,
  },
};

const claimSetCreationSlice = createSlice({
  name: 'claimSetCreation',
  initialState,
  reducers: {
    getClaimSetCreationOptions: (state) => {
      state.statuses.isOptionsLoading = true;
    },
    getClaimSetCreationOptionsSuccess: (state, { payload }: PayloadAction<ClaimSetCreationOptionsResponse>) => {
      state.options = payload;
      state.statuses.isOptionsLoading = false;
    },
    resetClaimSetCreationStatuses: (state) => {
      state.statuses = initialState.statuses;
    },
    updateClaimSetCreationFormValues: (
      state,
      {
        payload: { step, fields },
      }: PayloadAction<{
        step: ClaimSetCreationStep;
        fields: ClaimSetCreationIncidentType;
      }>,
    ) => {
      if (state.form[step]) {
        state.form[step] = fields as any;
      }
    },
    completeClaimSetCreation: (state) => {
      state.statuses.isCompleting = true;
    },
    resetClaimSetCreationSlice: () => initialState,
    completeClaimSetCreationSuccess: () => initialState,
    getCreateClaimSetExistingUserById: (_state, _action: PayloadAction<string>) => {},
    reportClaimSubmit: (_state, _action: PayloadAction<{ formId: string; data: any }>) => {},
  },
});

export const {
  reportClaimSubmit,
  getClaimSetCreationOptions,
  getClaimSetCreationOptionsSuccess,
  resetClaimSetCreationStatuses,
  updateClaimSetCreationFormValues,
  completeClaimSetCreation,
  completeClaimSetCreationSuccess,
  resetClaimSetCreationSlice,
  getCreateClaimSetExistingUserById,
} = claimSetCreationSlice.actions;

export const claimSetCreationReducer = claimSetCreationSlice.reducer;
export const claimSetCreationReducerPath = claimSetCreationSlice.reducerPath;
